// The selection tag: a small label that floats over whatever is selected on
// the map (a building, a wall structure, a unit in a raid) with its name and
// a health bar. It is DOM, not canvas, so it stays crisp at any zoom and
// screen readers and tests can read it. Modes place it every frame.
const el = document.getElementById('tag')!;
const nameEl = el.querySelector<HTMLElement>('.name')!;
const hpEl = el.querySelector<HTMLElement>('.hp')!;
const barEl = el.querySelector<HTMLElement>('.bar > i')!;

export function showTag(name: string, hp: number, maxHp: number): void {
  nameEl.textContent = name;
  hpEl.textContent = `${hp} / ${maxHp} hp`;
  const frac = maxHp > 0 ? Math.max(0, Math.min(1, hp / maxHp)) : 0;
  barEl.style.width = `${Math.round(frac * 100)}%`;
  barEl.className = frac > 0.5 ? 'ok' : frac > 0.25 ? 'hurt' : 'low';
  el.hidden = false;
}

export function hideTag(): void {
  el.hidden = true;
}

/** Puts the tag's bottom centre at a screen point. */
export function placeTag(x: number, y: number): void {
  el.style.transform = `translate(${Math.round(x)}px, ${Math.round(y)}px) translate(-50%, -100%)`;
}
